<template>
  <Picture
    :image-url="getAssetImage('toys.svg')"
    native-lazy
    :alt="alt"
    :pt="{
      img: {
        style: styles,
        class: imgClass,
      },
    }"
  />
</template>
<script setup>
import { computed } from 'vue';
import Picture from '@nuxt-common/atomic-ui/app/components/picture/Picture';

import getAssetImage from '~/utils/getAssetImage';

const props = defineProps({
  big: {
    type: Boolean,
    default: false,
  },
  imgStyle: {
    type: Object,
    default: () => ({}),
  },
  imgClass: {
    type: String,
    required: false,
    default: '',
  },
});

const alt = 'Toys R Us';

const styles = computed(() => ({
  ...props.imgStyle,
  width: props.big ? '87px' : '65px',
  height: props.big ? '24px' : '18px',
}));
</script>
